import SPHMediaLogoFooter from "@assets/SPHMediaLogo.svg";
import TMMobileLogoFooter from "@assets/tm_logo_mobile.png";
import { FooterAdvertise } from "@footer/FooterAdvertise";
import { FooterCopyright } from "@footer/FooterCopyright";
import { FooterLinks } from "@footer/FooterLinks";
import { FooterNewsletterSignup } from "@footer/FooterNewsletterSignup";
import type { ReactElement } from "react";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export type FooterProps = {
  testId?: string;
  className?: string;
  showNewsletterSignup?: boolean;
};

export function Footer({
  testId = "footer",
  className,
  showNewsletterSignup = true,
}: FooterProps): ReactElement {
  return (
    <>
      <footer
        className={twMerge(
          "bg-red-400 mt-500 max-w-full px-2 lg:px-0",
          className,
        )}
      >
        {showNewsletterSignup && <FooterNewsletterSignup />}
        <div className="flex">
          <div
            data-testid={`${testId}-footerContainer`}
            className="xl:max-w-xl lg:max-w-lg md:max-w-full sm:max-w-full w-full mx-auto py-0 lg:py-4 xs:px-sm xl:px-xxs font-primary max-xs:px-xxs max-xs:py-4"
          >
            <div className="inline-block md:w-8/12">
              <div className="xs:my-5 lg:my-md flex">
                <Link reloadDocument to="/" rel="home" title="Tamil Murasu">
                  <img
                    height="30px"
                    width="144px"
                    className="block mt-[7px]"
                    alt="Home"
                    src={TMMobileLogoFooter}
                  />
                </Link>
                <span className="border-l border-solid border-gray-400 mx-xs"></span>
                <Link
                  to="https://www.sph.com.sg/"
                  rel="home"
                  title="Home"
                  target="_blank"
                >
                  <img
                    height="47px"
                    width="139px"
                    alt="Home"
                    src={SPHMediaLogoFooter}
                  />
                </Link>
              </div>
              <FooterCopyright testId={testId} />
              <FooterLinks testId={testId} />
            </div>
            <FooterAdvertise testId={testId} />
          </div>
        </div>
      </footer>
    </>
  );
}
